// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Combine as RawCombine } from "lucide-react";
export const Combine = /* @__PURE__ */ createIcon(RawCombine, "Combine", 2);
